// extracted by mini-css-extract-plugin
module.exports = {"section":"Unsubscribe-module--section--VWvpN","formCont":"Unsubscribe-module--formCont--2V5O4"};